module.exports = __webpack_public_path__ + "assets/img/prize-3.baf0097e.jpg";